import { carrotClient } from "#/utils/CarrotClient"
import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { MemberJourneyData } from "#/types/memberJourney"
import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

const MEMBER_JOURNEY_QUERY_KEY = "MemberJourney"

/**
 * Fetches member journey and journey stage from various sources:
 * - CurrentMemberJourney
 * - RegistrationJourney
 * - CurrentCarrotPlanJourney
 * - CurrentRoutingJourney
 * - MostRecentSubmittedRoutingJourney
 *
 * CurrentMemberJourney returns the most recent journey from the member's CarrotPlan, RoutingInfo or registration.
 * Three variations exist based on which RoutingInfo record is considered in this determination:
 * - WithSubmittedRoutingInfo: considers the most recent submitted RoutingInfo only
 * - WithInProgressRoutingInfo: considers the most recent RoutingInfo whether submitted or in progress
 * - PreferSubmittedRoutingInfo: considers the most recent submitted RoutingInfo if it exists, falls back to in-progress RoutingInfo
 * */
export default function useGetMemberJourneyData(): UseQueryResult<MemberJourneyData, ResponseError> {
  return useQuery<MemberJourneyData, ResponseError>({
    queryKey: [MEMBER_JOURNEY_QUERY_KEY],
    queryFn: () => carrotClient.getMemberJourneyData(),
    retry: buildCarrotApiRetryPolicy(3)
  })
}
